import MultiForm from '@admin/components/multiform'
import PropTypes from 'prop-types'
import Details from './details'
import Publish from './publish'
import Design from './design'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Announcement)',
      action: '/api/admin/truevail/admin/announcements',
      method: 'POST',
      getSteps: this._getSteps,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps() {
    return [
      { label: 't(Details)', component: Details },
      { label: 't(Design)', component: Design },
      { label: 't(Publish)', component: Publish }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(announcement) {
    this.context.router.push(`/truevail/admin/announcements/${announcement.id}`)
    this.context.modal.close()
  }

}

export default New
